import mqtt from 'mqtt'
import { iot } from 'gipsy-api'
import logger from 'utils/logger'

const validateClientConnected = client => {
  if (!client) {
    throw new Error('Client is not connected yet. Call client.connect() first!')
  }
}

const getConnectionPayload = id => {
  try {
    return JSON.stringify({ clientId: id })
  } catch (err) {
    logger.error(err)
    return null
  }
}

const CLIENT_DISCONNECTED = 'client-disconnected'

class RealTimeClient {
  init = async userId => {
    this.userId = userId
    await this.connect()
  }

  connect = async () => {
    /* logic connection mqtt */
    const options = {
      will: {
        topic: CLIENT_DISCONNECTED,
        payload: getConnectionPayload(this.userId)
      }
    }

    let wssUrl
    try {
      wssUrl = await iot.get()
    } catch (err) {
      this.isConnected = false
      logger.error(err)
      return
    }

    this.client = mqtt.connect(wssUrl, options)
    this.isConnected = true
    this.client.on('close', this.onClose)
    this.client.on('message', this.onMessage)
  }

  mapTopicCallbacks = {}

  onMessage = topic => {
    validateClientConnected(this.client)
    const callbacks = this.mapTopicCallbacks[topic]
    for (let callbackObj of callbacks) {
      callbackObj.func()
    }
  }

  onClose = () => {
    validateClientConnected(this.client)
    this.client.end()
    this.isConnected = false
  }

  subscribe = (topic, callback, callbackId) => {
    validateClientConnected(this.client)
    const userIdTopic = `${topic}${this.userId}`
    this.client.subscribe(userIdTopic)
    this.mapTopicCallbacks[userIdTopic] = this.mapTopicCallbacks[userIdTopic] || []
    this.mapTopicCallbacks[userIdTopic].push({ func: callback, id: callbackId })
  }

  unsubscribe = (topic, callbackId) => {
    const userIdTopic = `${topic}${this.userId}`
    const callbacks = this.mapTopicCallbacks[userIdTopic]
    if (!callbacks) {
      return
    }
    for (let i in callbacks) {
      if (callbacks[i].id === callbackId) {
        callbacks.splice(i, 1)
      }
    }
  }
}

export default new RealTimeClient()



// WEBPACK FOOTER //
// ./src/features/realTimeClient/index.js